module.exports = __webpack_public_path__ + "static/media/04.bd3a7ba9.webp";